import DataSource from './data-sources';
import { pillarTwoReportId } from '../config/constants';

const PillarTwoDataSource = () => <DataSource templateId={pillarTwoReportId} />;
export default PillarTwoDataSource;